import React from 'react';
import { CircularProgress } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import FPHtmlViewer from 'UI/components/atoms/FPHtmlViewer';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { Endpoints } from 'UI/constants/endpoints';
import { UIStatus } from 'UI/constants/status';

import { LoaderContainer } from './DuplicatesDrawer.styled';
import { DuplicatesTable } from './DuplicatesTable';

export const DuplicatesDrawer = ({ candidate, jobOrder, onClose }) => {
  const params = { job_order_id: jobOrder?.id, candidate_id: candidate?.id };
  const queryParams = new URLSearchParams(params).toString();

  const { state } = useFetchWithStatusV2({
    endpoint: candidate?.id && jobOrder?.id ? `${Endpoints.SendoutDuplicates}?${queryParams}` : null
  });

  const isFetching = state.status === UIStatus.Loading;

  const duplicatesAlertText = strings.formatString(strings.sendoutsV2.drawers.duplicates.alert, {
    jobOrderTitle: jobOrder?.title,
    candidateName: candidate?.fullName
  });

  return (
    <FPDrawer
      FPDrawerProps={{ open: true }}
      CardHeaderProps={{ title: strings.sendoutsV2.drawers.duplicates.title }}
      onClose={onClose}
    >
      <When condition={isFetching}>
        <LoaderContainer>
          <CircularProgress />
        </LoaderContainer>
      </When>
      <When condition={state.status === UIStatus.Success}>
        <Alert severity="info">
          <FPHtmlViewer content={duplicatesAlertText} />
        </Alert>
        <DuplicatesTable data={state.results?.data} />
      </When>
    </FPDrawer>
  );
};
